import { Typography } from "@monolith-forensics/monolith-ui";
import { Helmet } from "react-helmet-async";
import styled from "styled-components";
import TabSection from "./components/TabSection";

const TeamSection = styled(({ className }) => {
  return (
    <div className={className}>
      <Helmet title="Team Management" />
      <Typography
        variant="h3"
        gutterBottom
        display="inline"
        style={{ margin: 0 }}
      >
        Team Management
      </Typography>
      <TabSection />
    </div>
  );
})`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export default TeamSection;
